// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3yhTN","title":"AfterBackImages_title__3Q-PZ","images":"AfterBackImages_images__3YPNZ"};